import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbDatepickerModule, NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { MediaModule, OutletPosition, provideOutlet } from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AccountOverviewModule } from '../account-overview/account-overview.module';
import { SearchBoxModule } from '../search-box/search-box.module';
import { NoMouseScrollModule } from '../shared/directives/no-mouse-scroll/no-mouse-scroll.module';
import { CheckoutModule } from '../shared/modules/checkout/checkout.module';
import { QuickOrderModule } from '../shared/modules/quick-order/quick-order.module';
import { ReceivingHoursAlertBannerModule } from '../shared/modules/receiving-hours-alert-banner/receiving-hours-alert-banner.module';
import { CustomAddToCartComponent } from './custom-add-to-cart/custom-add-to-cart.component';
import { EmptyCartComponent } from './custom-add-to-cart/empty-cart/empty-cart.component';
import { ProductDetailsComponent } from './custom-add-to-cart/product-details/product-details.component';
import { StandardCartComponent } from './custom-add-to-cart/standard-cart/standard-cart.component';
import { EditOrdersComponent } from './edit-orders/edit-orders.component';
import { MiniCartComponent } from './mini-cart/mini-cart.component';
import { SavedOrdersComponent } from './saved-orders/saved-orders.component';
import { ScheduleFutureshipCartComponent } from './schedule-futureship-cart/schedule-futureship-cart.component';
import { StandardCartCheckoutComponent } from './standard-cart-checkout/standard-cart-checkout.component';
import { StandardCartConfirmationComponent } from './standard-cart-confirmation/standard-cart-confirmation.component';

@NgModule({
  declarations: [
    CustomAddToCartComponent,
    StandardCartComponent,
    EmptyCartComponent,
    ProductDetailsComponent,
    MiniCartComponent,
    SavedOrdersComponent,
    EditOrdersComponent,
    StandardCartCheckoutComponent,
    StandardCartConfirmationComponent,
    ScheduleFutureshipCartComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    I18nModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    NgSelectModule,
    CheckoutModule,
    SearchBoxModule,
    QuickOrderModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgbDatepickerModule,
    AccountOverviewModule,
    ReceivingHoursAlertBannerModule,
    NgbPopoverModule,
    MediaModule,
    NoMouseScrollModule,
    MatProgressSpinnerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        saveOrderPageComponent: {
          component: () =>
            import('./saved-orders/saved-orders.component').then(
              (m) => m.SavedOrdersComponent
            ),
          guards: [AuthGuard],
        },
        SavedCartsComponent: {
          component: () =>
            import('./saved-orders/saved-orders.component').then(
              (m) => m.SavedOrdersComponent
            ),
          guards: [AuthGuard],
        },
        savedOrderDetailsPageComponent: {
          component: () =>
            import('./edit-orders/edit-orders.component').then(
              (m) => m.EditOrdersComponent
            ),
          guards: [AuthGuard],
        },
        PlaceOrderConfirmationComponent: {
          component: () =>
            import(
              './standard-cart-confirmation/standard-cart-confirmation.component'
            ).then((m) => m.StandardCartConfirmationComponent),
          guards: [AuthGuard],
        },
        CheckoutComponent: {
          component: () =>
            import(
              './custom-add-to-cart/standard-cart/standard-cart.component'
            ).then((m) => m.StandardCartComponent),
          guards: [AuthGuard],
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideOutlet({
      id: 'MiniCart',
      position: OutletPosition.REPLACE,
      component: MiniCartComponent,
    }),
    provideOutlet({
      id: 'FutureShipPageSlot',
      position: OutletPosition.REPLACE,
      component: ScheduleFutureshipCartComponent,
    }),
  ],
})
export class CustomAddToCartModule {}
